import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
import { RoleNomenclature } from '../../../shared/nomenclatures/role-nomenclature';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar-component.html',
})
export class SidebarComponent implements OnInit, OnDestroy {
  roleId: number;
  currentRoute: string = '';
  private routerSubscription: Subscription;
  readonly RoleNomenclature = RoleNomenclature;

  isCollapsed = false;
  isMobile = false; 

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private router: Router
  ) {
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url;
    });
    
    this.checkScreenSize();
  }

  ngOnInit(): void {
    const user = this.userService.getLoggedInUser();
    if (user) {
      this.roleId = user.roleId;
    }
    this.currentRoute = this.router.url;
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth < 1024; 
    if (this.isMobile) {
      this.isCollapsed = true; 
    } else {
      this.isCollapsed = false;
    }
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  openSidebar() {
    this.isCollapsed = false;
  }

  closeSidebar() {
    if (this.isMobile) {
      this.isCollapsed = true;
    }
  }

  onLinkClick() {
    if (this.isMobile) {
      this.isCollapsed = true;
    }
  }

  isActive(route: string): boolean {
    return this.currentRoute.includes(route);
  }

  getActiveClass(route: string): string {
    if (this.isActive(route)) {
      return 'bg-gradient-to-r from-[#BF7A7A] to-[#6E7E97] text-white shadow-md';
    }
    return 'text-slate-600 hover:bg-slate-100';
  }

  logout() {
    this.authService.logout();
  }
}